import { logWarn } from '@ptek/client-logger';

const LEASE_ID_KEY_PREFIX = 'scribe.recordingLeaseId.';
const RECORDING_DEVICE_ID_KEY = 'scribe.recordingDeviceId';

const leaseIdKey = (sessionId: string) => `${LEASE_ID_KEY_PREFIX}${sessionId}`;

/** sessionStorage is an optional browser capability (privacy mode can throw). */
export function readPersistedRecordingLeaseId(
  sessionId: string
): string | null {
  try {
    return window.sessionStorage.getItem(leaseIdKey(sessionId));
  } catch (error) {
    logWarn(
      'recordingLeaseStorage',
      'Unable to read persisted recording lease',
      {
        sessionId,
        error,
      }
    );
    return null;
  }
}

export function persistRecordingLeaseId(
  sessionId: string,
  leaseId: string | null
): void {
  try {
    if (leaseId === null) {
      window.sessionStorage.removeItem(leaseIdKey(sessionId));
      return;
    }
    window.sessionStorage.setItem(leaseIdKey(sessionId), leaseId);
  } catch (error) {
    logWarn('recordingLeaseStorage', 'Unable to persist recording lease', {
      sessionId,
      error,
    });
  }
}

/** Returns the browser-scoped identity used to compare recording computers. */
export function readOrCreatePersistedRecordingDeviceId(): string | null {
  try {
    const persisted = window.localStorage.getItem(RECORDING_DEVICE_ID_KEY);
    if (persisted) return persisted;

    const deviceId = window.crypto.randomUUID();
    window.localStorage.setItem(RECORDING_DEVICE_ID_KEY, deviceId);
    return deviceId;
  } catch (error) {
    logWarn(
      'recordingLeaseStorage',
      'Unable to read or persist recording device identity',
      { error }
    );
    return null;
  }
}
